// Separate event listener setup
export const setupSecurityEventListeners = () => {
  document.addEventListener('contextmenu', (e) => e.preventDefault());
  document.addEventListener('keydown', event => {
    if ((event.ctrlKey || event.metaKey) && event.shiftKey &&
      (event.key === 'I' || event.key === 'J') || event.keyCode === 123) {
      event.preventDefault();
    }
  });
};